import { ReactNode } from "react"
import { Loader2 } from "lucide-react"
import PrimaryBtn from "../primary-btn"

interface AuthSubmitBtnProps {
  loading: boolean
  children: ReactNode
  className?: string
}

/** Full-width submit button shared by the login/forgot-password/reset-password forms. */
const AuthSubmitBtn = ({
  loading,
  children,
  className = "text-base"
}: AuthSubmitBtnProps) => (
  <PrimaryBtn
    className={`${loading ? "pointer-events-none" : ""} w-full ${className}`}
    type="submit"
    disabled={loading}
    onClick={() => {}}
  >
    {loading ? (
      <Loader2
        className="animate-spin h-5 w-5 text-primary-alt-400"
        aria-hidden="true"
      />
    ) : (
      <span>{children}</span>
    )}
  </PrimaryBtn>
)

export default AuthSubmitBtn
